<template>
    <div class="configuration-page">
        <div class=" configuration-container">
              <div class="inputs-container">
                  <p class="main-title">Customize your email</p>
                  <p class="main-subtitle">Your recipient will receive an email prompting them to redeem their gift. Pick a header, write your message and schedule when you’d like us to notify them and we’ll handle the rest.</p>
                  <div class="add-gift">
                        <p class="title">Add a gif header</p>
                        <div class="categories-container">
                        <button @click="selectOccasion(occasion)" v-for="occasion in allOccasions" :key="occasion" :class="occasion == selectedOccasion ? 'selected' : ''">{{ occasion }}</button>
                        </div>
                        <div class="gifs-container">
                            <img :class="gif == selectedGif ? 'selected' :'' " @click="selectGif(gif)" :src="gif" v-for="gif in currentGifs" :key="gif"/>
                            <div :class="selectedGif == null ? 'selected' :'' " @click="selectGif(null)">
                                <p>No Image</p>
                            </div>
                        </div>
                  </div>
                  <div class="message-container">
                      <p class="title">Add your message</p>
                      <textarea placeholder="Start typing here..." v-model="message" cols="30" rows="3" id="message"></textarea>
                  </div>
                  <div  v-if="emailFileData.length == 1" class="date-container">
                      <p class="title">Select the date you’d like us to email your recipients</p>
                      <div class="date-input">
                          <DatePicker
                              v-model="selectedDate"
                              color="teal"
                              trim-weeks
                              :min-date="new Date()"
                              :attributes='calendarAttrs'
                          />
                          <div class="date-details">
                              <div class="date-detail">
                                  <p class="circle teal"></p>
                                  <div class="date-copy">
                                      <p class="title">Recipients Notification Date:</p>
                                      <p class="subtitle">{{ currentDateString }}</p>
                                  </div>
                              </div>
                              <div class="date-detail">
                                  <p class="circle indigo"></p>
                                  <div class="date-copy">
                                      <p class="title">Estimated Delivery Window:</p>
                                      <p class="subtitle">{{ estimatedShippingDate }}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <button v-if="!isMobile()" @click="createGifts()" class="happybox-button yellow" :class="isLoading ? 'isLoading' : ''">{{buttonText}}</button>
              </div>
              <div class="preview-container">
                  <p class="title">Email Preview</p>
                  <p class="subtitle">Here's what your recipient will see:</p>
                  <div class="blue-container">
                      <div class="mail-preview">
                        <img class="hb-logo" src="https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_300x.gif?v=1658235293"/>
                          <p class="mail-title">
                              Hey [Recipient], [From] sent you a gift! 🎉
                          </p>
                          <p class="mail-subtitle">Here's their message:</p>
                          <img class="mail-gif" :src="selectedGif">
                          <p class="mail-message">{{ message }}</p>
                      </div>
                  </div>
                  <div class="recipients-container">
                    <p class="recipient-title">Recipients</p>
                    <div class="shipped-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th v-if="emailFileData.length > 1">Notification Date</th>
                                    <th>From</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="recipient in emailFileData" :key="recipient.email">
                                    <td>{{recipient.firstName}} {{ recipient.lastName }}</td>
                                    <td>{{recipient.email}}</td>
                                    <td v-if="emailFileData.length > 1">{{recipient.notificationDate.toLocaleString("en-US",{}).split("T")[0]}}</td>
                                    <td>{{recipient.from}}</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                  </div>
                  <button v-if="isMobile()" @click="createGifts()" class="happybox-button yellow" :class="isLoading ? 'isLoading' : ''">{{buttonText}}</button>
            </div>
        </div>
        <div></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import axios from "axios";
export default {
    components: {
        Calendar,
        DatePicker
    },
    props:{
        emailFile: Object
        ,product: Object
    },
    data(){
        return{
            gifs:[
            ,{src:"https://media.giphy.com/media/BPJmthQ3YRwD6QqcVD/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/HloNK1z39EkEQcreIo/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/s2qXK8wAvkHTO/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/G96zgIcQn1L2xpmdxi/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/artj92V8o75VPL7AeQ/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/35HTaxVJWzp2QOShct/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ2FwYmRqYWFhenRzZzNjdG54bGF2Nng4ZTh2amN6aGs5enF2cmU4dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/htHMAjOrrDcUXW7Bn8/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/B8CHqQLm4dXMUNmz0z/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/gFi7V9CRBQVW0/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/g5R9dok94mrIvplmZd/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/jCz1AWFI4SnRzCmj9l/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/WXdDuZ2ADlqMjvi3Qh/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l4KibWpBGWchSqCRy/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/kaMwwM91UCxstRfvA3/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l4KhS0BOFBhU2SYIU/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/5YULt69vGGexq/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/oVzzsjnJaCpr2/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/xThuWkj1FAYH4wmGfC/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l46CtujrJsJzKhQ88/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/lrUU99mair7hf75Eb0/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/fVtcfEXWQJQUbsF1sH/giphy-downsized-large.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/xUPGcxpCV81ebKh7Vu/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/r7GrCqj3H1ZxlDuwoL/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/StuemRSudGjTuu5QmY/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/13B3a2WWKcEo9O/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/Svjh8g9spSoO7YxYAm/giphy.gif", occasion: "Thank you"}
            ],
            message:"",
            currentGif: null,
            selectedDate: new Date(),
            isLoading: false,
            selectedOccasion: "Celebration"
        }
    },
    computed:{
        emailFileData(){
            return this.emailFile.data;
        },
        addressQty(){
            return this.emailFile.emailqty;
        },
        compressedEmailFile(){
            return this.emailFile.compressedData;
        },
        collectionPrice(){
            return parseInt(this.product.variants[0].price)
        },
        selectedGif(){
            return this.currentGif;
        },
        calendarAttrs(){
            let nextDate = this.addWorkDays(new Date(this.currentDate),2);
            let finishDate = new Date(nextDate).setDate(nextDate.getDate() + 7);
            return [
                {
                    key: 'shipping',
                    highlight: 'indigo',
                    dates: { start: nextDate, end: finishDate },
                },
            ];
        },
        currentDate(){
            if(this.selectedDate)
                return this.selectedDate

            return new Date();
        },
        currentDateString(){
            return this.currentDate.toLocaleString('default', {  day: "numeric",month: 'long' });
        },
        estimatedShippingDate(){
            let nextDate = this.addWorkDays(new Date(this.currentDate),2);
            let finishDate = new Date(nextDate).setDate(nextDate.getDate() + 7);
            finishDate = new Date(finishDate);

            return nextDate.toLocaleString('default', {  day: "numeric",month: 'long' }) + " - " + finishDate.toLocaleString('default', {  day: "numeric" ,month: 'long' });
        },
        buttonText(){
            return this.isLoading ? "loading..." : "Proceed to Checkout"
        },
        currentGifs(){
            if(this.selectedOccasion != "View All"){
                return this.gifs.filter(x => x.occasion == this.selectedOccasion).map(x => x.src);
            }

            return this.gifs.map(x => x.src);
        },
        allOccasions(){
            let occasions = [...new Set(this.gifs.map(x => x.occasion))];

            occasions.push("View All")
            return occasions
        }
    },
    methods:{
        selectGif(gif){
            this.currentGif = gif;
        },
        addWorkDays(date, days) {   
            while (days > 0) {
                date.setDate(date.getDate() + 1);
                if (date.getDay() != 0 && date.getDay() != 6) {
                days -= 1;
                }
            }          
            return date;
        },
        async createGifts(){
            this.isLoading = true;
            this.$emit("end",{
                recipients: this.emailFileData
                ,compressedEmails: this.compressedEmailFile
                ,emailQty: this.addressQty
                ,notificationDate: this.selectedDate
                ,gif:this.selectedGif
                ,message: this.message
                ,product: this.product
            })
        },
        isMobile() {
            return window.innerWidth < 768;
        },
        selectOccasion(value){
            this.selectedOccasion = value;
        },
    }
}
</script>

<style scoped>
.configuration-page{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.gift-banner-container{
    display: flex;
    gap: 15px;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.configuration-container{
    width: 100%;
    display: flex;
    padding: 2% 5% 5%;
    justify-content: space-between;
}

.inputs-container,.preview-container{
    width: 48%;
}

.preview-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.preview-container .title{
    font-size: 3vw;
    font-family: moret;
    font-weight: 300;
    line-height: 1;
    text-align: center;
    color: #0f0c38;
}

.preview-container .subtitle{
    font-family: "karla";
    font-size: 1.2vw;
    line-height: 1;
    text-align: center;
    color: #0f0c38;
}

.blue-container{
    border-color: #e8e1ea;
    border-width: 1px;
    border-style: solid;
    border-radius: 28px;
    filter: drop-shadow(0px 0px 3px rgba(0,0,0,0.08 ));
    background: #f2f6ff;
    padding: 5%;
}

.blue-container .main-title{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.2;
    color: #5e5e7f;
    border-bottom: 1px solid #a8aac2;
    padding-bottom: 2%;
    width: 100%;
}

.mail-preview{
    border: 1px solid #eae1eb;
    border-radius: 5px;
    background: #ffffff;
    padding: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.hb-logo{
    width: 15%;
}

.mail-title{
    font-family: 'moret';
    color: #0f0c38;
    font-size: 1.6vw;
    text-align: center;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
}

.mail-subtitle{
    color: #0f0c38;
    font-size: 1vw;
    margin-bottom: 0.5rem;
}

.mail-preview .mail-gif{
    width: 100%;
}

.mail-message{
    color: #0f0c38;
    font-size: 1vw;
    margin-top: 1rem;
    white-space: break-spaces;
}

.mail-legend{
    color: #0f0c38;
    font-size: 0.8vw;
}

.inputs-container .main-title{
    font-size: 3vw;
    font-family: moret;
    font-weight: 300;
    line-height: 1;
    text-align: left;
    color: #0f0c38;
    margin-bottom: 5%;
}

.inputs-container .main-subtitle{
    font-family: "karla";
    font-size: 1.2vw;
    line-height: 1.4;
    text-align: left;
    color: #0f0c38;
}

.add-gift .title,.message-container .title,.date-container .title{
    font-size: 1.5vw;
    line-height: 1;
    text-align: left;
    color: #0f0c38;
    margin-bottom: 2%;
    margin-top: 5%;
    font-weight: 700;
}

.message-container{
    padding: 5% 0%;
}

textarea{
    width: 90%;
    min-height: 20vh;
}

textarea{
    background: #FFFFFF !important;
    border: 1px solid #E5E7EB !important;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08) !important;
    border-radius: 4px !important;
    color: #0F0C38;
    height: unset !important;
    font-size: 1.2vw;
    accent-color: black;
}

textarea:focus-visible{
    border: 1px solid #E5E7EB !important;;
    outline: none;
}

.categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 2%;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 0.9vw;
    line-height: 1.3;
    color: #0F0C38;
}

.categories-container button.selected{
    font-weight: bold;
    border-bottom: 1px solid #0F0C38;
    padding-bottom: 1%;
}

.gifs-container{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 5px;
}

.gifs-container img{
    width: 23%;
    cursor: pointer;
}

.gifs-container div{
    width: 23%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8e1ea;
    min-height: 12vh;
}

.gifs-container div p{
    font-family: karla;
    font-size: 1.15vw;
    line-height: 1;
    margin: unset;
    color: #0f0c38;
}

.gifs-container .selected{
    border: 2px solid greenyellow;
}

.date-input{
    display: flex;
    justify-content: space-between;
    padding-bottom: 5%;
    flex-direction: column;
}

.date-details{
    width: 50%;
    display: flex;
    gap: 10px;
    flex-direction: column;
}

.date-detail{
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.date-copy .title{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.7;
    font-weight: bold;
    text-align: left;
    color: #0f0c38;
    margin: 0;
}

.date-copy .subtitle{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.7;
    text-align: left;
    color: #0f0c38;
    margin: 0;
}

.circle{
    width: 2vw;
    height: 2vw;
    margin: 0;
    border-radius: 2vw;
}

.circle.teal{
    background-color: #319795;
}

.circle.indigo{
    background-color: #5a67d8;
}

.finish-container{
    width: 100%;
    padding: 0% 5% 3%;
    text-align: right;
}

.happybox-button.orange{
    margin-top: 2%;
}

.preview-container .recipient-title{
    font-size: 1.5vw;
    line-height: 1;
    color: #0f0c38;
    margin-top: 5%;
    margin-bottom: 2%;
    font-weight: bold;
  }

  .recipients-container{
    width: 100%;
  }

  .shipped-table{
        width: 100%;
        overflow-x: scroll;
    }
    .shipped-table th{
        font-size: 1vw;
        border: unset;
        color: #0f0c38;
        padding: unset;
        text-align: center;
    }
    .shipped-table tbody{
        background-color: #fafbff;
        font-size: 1vw;
    }

    .shipped-table td{
        padding: 5px;
        text-align: center;
    }

    .shipped-table tbody,.shipped-table tbody th,.shipped-table tbody td {
        border: 1px solid #b5b6b8;
        border-collapse: collapse;
    }

@media only screen and (min-device-width: 767px){
    .configuration-container{
        transform: translateX(0px);
        position: relative;
    }

    .preview-container{
        border-left: 1px solid #e8e1ea;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 80vh;
        max-height: 80vh;
        overflow-y: scroll;
        padding: 0 5%;
        position: sticky;
        top: 15%;
    }

    .blue-container{
        max-height: 90%;
    }

    .preview-container{
        position: sticky;
        top: 15%;
        height: 80vh;
        display: flex;
        flex-direction: column;
        align-items: center; 
        max-height: 80vh;
    }

    .mail-preview{
        height: 100%;
        overflow-y: scroll;
    }

    .happybox-button.orange{
        width: 90%;
        margin-top: 7%;
    }
}

@media only screen and (max-device-width: 767px){
    .configuration-container{
        flex-direction: column;
        padding: 5% 10%;
    }

    .gift-banner-container{
        flex-direction: column;
    }

    .inputs-container,.preview-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .inputs-container .main-title{
        text-align: center;
        font-size: 6vw;
        width: 70%;
    }

    .inputs-container .main-subtitle{
        font-size: 3.5vw;
        text-align: center;
    }

    .gifs-container div{
        width: 60%;
        flex-shrink: 0;
    }

    .gifs-container div p{
        font-size: 3vw;
    }

    .add-gift .title,.message-container .title,.date-container .title{
        font-size: 5vw;
        text-align: center;
        margin-bottom: 5%;
    }

    .categories-container button{
        font-size: 2vw;
    }

    .gifs-container{
        overflow-x: scroll;
        flex-wrap: nowrap;
    }

    .gifs-container img{
        width: 66%;
        flex-shrink: 0;
    }

    .message-container{
        width: 100%;
    }

    textarea{
        font-size: 3.5vw;
        width: 100%;
    }

    .date-container .title{
        width: 100%;
        padding: 0 17%;
    }

    .date-input{
        flex-direction: column;
        gap: 20px;
    }

    .date-details{
        width: 70%;
    }

    .circle{
        width: 5vw;
        height: 5vw;
        margin: 0;
        border-radius: 5vw;
    }

    .date-copy .title{
        font-size: 3.5vw;
        margin: 0;
        line-height: 1.2;
        padding: 0;
    }

    .date-copy .subtitle{
        font-size: 3vw;
    }

    .blue-container .main-title{
        font-size: 3vw;
    }

    .preview-container .title{
        font-size: 6vw;
    }

    .preview-container .subtitle{
        font-size: 4vw;
    }

    .mail-title{
        font-size: 6vw;
    }

    .mail-subtitle{
        font-size: 4.5vw;
    }

    .mail-message{
        color: #0f0c38;
        font-size: 3.5vw;
        margin-top: 1rem;
    }

    .mail-legend{
        color: #0f0c38;
        font-size: 3vw;
        text-align: center;
    }

    .happybox-button.orange{
        width: 100%;
        margin-top: 10%;
    }

    .finish-container{
        padding: 5% 5% 15%;
    }

    .separator{
        width: 100%;
        height: 2px;
        background-color: #e8e8e8;
        margin: 10% 0%;
        display: block;
    }
}
</style>